import { apiRequest } from './api';

export const serviceService = {
  getServices: () => apiRequest('/api/services'),
  getFeaturedServices: () => apiRequest('/api/services/featured'),
  getServiceBySlug: (slug) => apiRequest(`/api/services/${slug}`)
};
